export const subscriptionQueryKeys = {
  all: () => ['billing', 'subscription'],
  usedSeats: () => [...subscriptionQueryKeys.all(), 'used'],
};
